import React from "react";
import { Link } from "react-router-dom";

interface FooterLinkProps {
    link: {
        url: string;
        title: string;
        target?: string;
        linkType: string;
        ariaLabel?: string;
        route?: {
            path?: string;
        };
    }[];
}

interface LinkProps {
    href: string;
    target?: string;
    ariaLabel?: string;
}

const FooterLink: React.FC<FooterLinkProps> = ({ link }) => {
    if (!Array.isArray(link) || link.length === 0) {
        return null; // or you can return a fallback UI
    }

    const [linkEl] = link;
    const linkProps: LinkProps = {
        href: linkEl.url,
        target: linkEl.target,
    };

    return linkEl.route && linkEl.route?.path ? (
        <Link
            aria-label={linkEl.ariaLabel}
            to={linkEl.route.path}
            target={linkEl.target || "_self"}
        >
            {linkEl.title}
        </Link>
    ) : (
        <a {...linkProps}>{linkEl.title}</a>
    );
};

export default FooterLink;
